// extracted by mini-css-extract-plugin
export default {"form":"CancelarPedidoBmaAcesso_form__0apO2","areaBtn":"CancelarPedidoBmaAcesso_areaBtn__WL3x5","btn":"CancelarPedidoBmaAcesso_btn__CVDzz"};